$.browser = {};
(() => {
  $.browser.msie = false;
  $.browser.version = 0;
  if (navigator.userAgent.match(/MSIE ([0-9]+)\./)) {
    $.browser.msie = true;
    $.browser.version = RegExp.$1;
  }
})();

$(() => {
  if (!$.browser.msie) return;

  $('body').append(
    $('<div class="ie">').append('<iframe src="/unsupported-browser.html"></iframe>')
  );
});
